// extracted by mini-css-extract-plugin
export default {"PageLayout":"paginated-archive-view-module__PageLayout--k80zG","Box":"paginated-archive-view-module__Box--dNTV9","ArchiveList":"paginated-archive-view-module__ArchiveList--ZCXc6"};